// this is an autogenerated file from App/Account/Content/Tasks/mutation-delete-task-assignee.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Tasks($task_id: uuid!) {
  delete_tasks_assignees(where: { task_id: { _eq: $task_id } }) {
    affected_rows
  }
}

`